import React from 'react';
import { Apify, Importify } from './Apify';

/* NOTE methods starting with "render_" are conveniently wrapped and exported
 * via the SR dictionary; see below */
class NoSkin {
	constructor(skin_id) {
		this.skin_id = skin_id;
	}

	get_wrap_class() {
		return this.skin_id ? "adskin_" + this.skin_id : "";
	}

	gfxpath(res) {
		return "/gfx/skins/" + this.skin_id + "/" + res;
	}

	get_logo_path() {
		return this.gfxpath("logo.svg");
	}

	should_advertise_aktieportfoeljen() {
		return true;
	}

	render_prize_list(prize_list) {
		const imgs = ['medal-gold-0.svg', 'medal-silver-0.svg', 'medal-bronze-0.svg'];
		var img;
		var divs = [];
		var place = 1;
		for (const prize of prize_list) {
			img = imgs.shift() || img;
			divs.push(
				<div key={place} className="ad_prize_list_element">
					<img className="prize_cup" src={"/gfx/" + img} alt={place}/>
					{prize}
				</div>
			);
			place++;
		}
		return divs;
	}

	render_game_header() {
		return null;
	}

	render_game_middle() {
		return null;
	}

	render_game_lower_half() {
		return null;
	}

	render_pending_game_header() {
		return null;
	}

	render_standard_public_game_card_header() {
		return (
			<div style={{borderRadius: "4px 4px 0px 0px", overflow: "hidden"}}>
				<img src={this.gfxpath("gamecard.svg")} alt="" className="ad_game_card_title_img"/>
			</div>
		);
	}

	render_public_game_card_header() {
		return null;
	}

	render_public_game_card_footer() {
		return null;
	}

	render_game_subtitle() {
		return null;
	}

	render_standard_game_logo(alt) {
		return <img src={this.get_logo_path()} alt={alt || ""}/>
	}

	render_game_logo() {
		return null;
	}

	render_game_info() {
		return null;
	}

	render_eula() {
		return <span>You must agree to click this checkbox, and actually click it, to join this game</span>
	}

	get_eula_components() {
		return [
			(props) => {
				return (
					<div className="pb-3">
						<input type="checkbox" checked={props.value} onChange={props.toggle}/>
						{this.render_eula()}
					</div>
				);
			},
		];
	}

	wrap(children) {
		return (
			<div className={this.get_wrap_class()}>
				{children}
			</div>
		);
	}
}

class Skin extends NoSkin {
	should_advertise_aktieportfoeljen() {
		return false;
	}
}

const SkinContext = React.createContext(new NoSkin());

const mk_skin_component = (fn) => Importify().with_predicate(props => !!props.skin_id).with_module_from_props(props => "skins/" + props.skin_id).wrap((props) => {
	return fn(props, props.module ? (new props.module.default(props.skin_id)) : (new NoSkin()));
});

const SkinWrapperBySkinId = mk_skin_component((props, skin) => {
	return (
		<SkinContext.Provider value={skin}>
			{skin.wrap(props.children)}
		</SkinContext.Provider>
	)
});

const SkinProvider = mk_skin_component((props, skin) => {
	return React.Children.map(props.children, child => React.cloneElement(child, {...props, skin}));
});

const SkinWrapperByGameId = Apify("/z/skin_id_by_game_id")
	.with_query_from_props((props) => ({id: props.id}))
	.with_response_prop("skin_id")
	.wrap(SkinWrapperBySkinId);

const SkinWrapperByPortfolioId = Apify("/z/skin_id_by_portfolio_id")
	.with_query_from_props((props) => ({id: props.id}))
	.with_response_prop("skin_id")
	.with_4xx_prop()
	.wrap(SkinWrapperBySkinId);

const SkinWrapperByGameOrPortfolioId = (props) => {
	if (props.portfolio_id) {
		return <SkinWrapperByPortfolioId id={props.portfolio_id} {...props}/>
	} else if (props.game_id) {
		return <SkinWrapperByGameId id={props.game_id} {...props}/>
	} else {
		return props.children;
	}
}

const SR = (() => {
	var sr = {};
	for (var method of Object.getOwnPropertyNames(NoSkin.prototype)) {
		if (!method.startsWith("render_")) continue;
		sr[method] = ((method) => () => <SkinContext.Consumer>{skin => skin[method]()}</SkinContext.Consumer>)(method);

	}
	return sr;
})();

export { Skin, SkinWrapperByGameOrPortfolioId, SkinProvider, SkinContext, SR };



// WEBPACK FOOTER //
// ./src/skin.js